export default __webpack_public_path__ + "static/media/eco-friendly-background-min.bb59553f.png";